import { getLanguageFromStorage } from 'syf-js-utilities';
import i18n, { translate } from '../strings/i18n';
const getTranslation = (lang = getLanguageFromStorage()) => {
    i18n.changeLanguage(lang);
    const labelsFromTranslate = {
        firstNamePlaceholder: translate('addAuthUserScreen.firstNameInputPlaceholder'),
        firstNameHelpText: translate('addAuthUserScreen.firstNameInputHelpText'),
        firstNameError: translate('addAuthUserScreen.firstNameInputError'),
        lastNamePlaceholder: translate('addAuthUserScreen.lastNameInputPlaceholder'),
        lastNameHelpText: translate('addAuthUserScreen.lastNameInputHelpText'),
        lastNameError: translate('addAuthUserScreen.lastNameInputError'),
        birthDatePlaceholder: translate('addAuthUserScreen.birthDateInputPlaceholder'),
        birthDateHelpText: translate('addAuthUserScreen.birthDateInputHelpText'),
        birthDateInvalidError: translate('addAuthUserScreen.birthDateInputInvalidDateError'),
        birthDateFutureError: translate('addAuthUserScreen.birthDateInputFutureError'),
        birthDatePastError: translate('addAuthUserScreen.birthDateInputPastYearError'),
        birthDateTodayError: translate('addAuthUserScreen.birthDateInputTodayError')
    };
    return {
        ...labelsFromTranslate,
        inputTypeHelpText: {
            authorizedUserFirstName: labelsFromTranslate.firstNameHelpText,
            authorizedUserLastName: labelsFromTranslate.lastNameHelpText,
            authorizedUserBirthDate: labelsFromTranslate.birthDateHelpText
        },
        inputErrorTypeText: {
            authorizedUserFirstName: labelsFromTranslate.firstNameError,
            authorizedUserLastName: labelsFromTranslate.lastNameError,
            authorizedUserBirthDate: labelsFromTranslate.birthDateHelpText,
            authorizedUserInvalidBirthDate: labelsFromTranslate.birthDateInvalidError,
            authorizedUserFutureBirthYear: labelsFromTranslate.birthDateFutureError,
            authorizedUserPastBirthYear: labelsFromTranslate.birthDatePastError,
            authorizedUserTodayBirthDate: labelsFromTranslate.birthDateTodayError
        }
    };
};
export default getTranslation;
